import React from 'react';
import { withStyles } from '@material-ui/styles';
import MuiRadio from '@material-ui/core/Radio';

import {
  secondary300,
  secondary200,
} from '../../../src/themes/colors';

const styles = theme => ({
  root: {
    color: secondary300,
    '&:hover': {
      backgroundColor: 'transparent',
      color: theme.palette.primary.main,
    },
  },
  checked: {
    color: theme.palette.primary.main,
  },
  disabled: {
    backgroundColor: 'transparent !important',
    color: `${secondary200} !important`,
  },
});

const Radio = (props) => {
  const { classes } = props;
  return (
    <MuiRadio
      classes={{
        root: classes.root,
        checked: classes.checked,
        disabled: classes.disabled,
      }}
      disableRipple
      color="default"
      {...props}
    >
      {props.children}
    </MuiRadio>
  );
};

export default withStyles(styles)(Radio);
